<template>

<span class="inline_flex popoverRecap"> 




<van-button icon="cart-o" @click="this.showRecap = true" type="primary" >{{ $t('Ajouter au panier Rexel') }} </van-button>




<van-popup closeable  class=" all_border_radius"  v-model:show="showRecap" style="max-width: 80vw;text-align: left !important;" :style="{ padding: '20px 40px 20px 40px' }">

  <h3 class="align-center">{{ $t('Récapitulatif') }} </h3>

  <van-divider>  </van-divider>

  <div class="align-center" >
    {{ $t('Sauvegarder session') }}
  
<b>{{ sessionId }}</b>
</div>
<van-divider >  </van-divider>

<van-space :size="30" wrap>

  <div class="all_border_radius" style="    min-width: 220px;
    text-align: center; padding: 10px; background: #f3f2f5" v-for="item in StoreShowPrePanierListe"  :key="item.id">
    
   

<span   v-if="item.pa_ref_palier">
  <b style="vertical-align: sub;margin-right: 10px;">{{ item.ref_prk }}</b>

<van-button v-if="!showDoc(item)"   class="m-r1" size="small"  type="primary">
  <Spinner />
</van-button>

<van-button  v-if="showDoc(item)" @click="GoFicheTech(item)"  class="m-r1" size="small"  type="primary">
    <van-icon name="description"  size="17px" /> 
</van-button>

</span>

   
  </div>
</van-space>

<span class="van-notice-bar all_border_radius" style="padding: 10px;background:#ecf9ff;color:#1989fa;height: auto;">
 <van-icon  style="margin-left: 0px; margin-right: 20px;" class="icon_info" color="#1989fa"  name="info-o" size="2rem" /> 
  <span class="text-info-number" style="padding: 6px;">
    {{$t('Téléchargez instantanément toutes les fiches techniques de votre session.')}}
  </span>
</span>



<br>
<div style="text-align: right !important;">

  <van-button
class="m-r1" 
plain
@click="addCart()" 
type="primary">
    {{$t('Continuer sans télécharger')}}
</van-button>



  <van-button

loading-type="spinner" 
:disabled="ficheTechniqueLoading.some(status => status !== false)" 

:loading = "ficheTechniqueLoading.some(status => status !== false)"
:loading-text="$t('Tout télécharger + continuer')"  
@click="GoFichesTechs()"  
class="m-r1" 
type="primary">
    {{$t('Tout télécharger + continuer')}}
</van-button>

</div>


</van-popup>
</span>
</template>

<script>
import Spinner from '../../loader/LoaderSimple.vue' ;
export default {
  components: {
    Spinner,
  },
  data() {
    return {
      showRecap: false,
    }
  },
  computed: {
    storeSessionId(){
        return this.$store.state.storeUser.sessionId
      },
    showDoc() {
      return (id_perso) => {

      return !this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus.includes(id_perso.id_perso);
    };
    },
     /** PrePanier du store */
     StoreShowPrePanierListe() {
                    return this.$store.state.storePrePanier.StoreShowPrePanierListe
                },

    StoreEnvWeb() {
                    return this.$store.state.storeGlobal.StoreEnvWeb
                },
                //store lang
    StoreLang() {
                    return this.$store.state.storeUser.lang
                },
    ficheTechniqueLoading() {
      //console.log("ficheTechniqueLoading")
      //console.log(this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus.some(status => status !== false))
                    // check if there is any fiche technique not currently equal to false
                    return this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus
                },
    sessionId() {
      //console.log("ficheTechniqueLoading")
      //console.log(this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus.some(status => status !== false))
                    // check if there is any fiche technique not currently equal to false
                    return this.$store.state.storeUser.sessionId
                },
  },
  created() {
   
      },
  methods:{
    GoFicheTech(item){

var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso ;
window.open(this.$store.state.storeGlobal.StoreApi + '/pdf/' + ref_prk + '.pdf', '_blank');

//this.showDoc = false;
  
  /*
var a = document.createElement("a");
a.href = window.URL.createObjectURL("http://localhost:8080/pdf/PRK_8PKM3LCLC120.pdf");
a.download = "FILENAME.pdf";
a.click();
*/


},


     GoFichesTechs(){

      this.addCart();
      
      const jsonData = {};
      jsonData.data = [];

      jsonData.push = function(data) {
        this.data.push(data);
      };

      

      const userId = this.$CryptoJS.AES.encrypt( this.$store.state.storeUser.sessionId , process.env.VUE_APP_SALT_ENCODE).toString();

      const refArray = this.$store.state.storePrePanier.StoreShowPrePanierListe

for (let item of refArray) {
  var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso + '.pdf' ;
  jsonData.push(ref_prk);
}
      const jsonUrl = JSON.stringify(jsonData.data);
      const jsonUrlEncrypt = encodeURIComponent(this.$CryptoJS.AES.encrypt( jsonUrl , process.env.VUE_APP_SALT_ENCODE).toString());
     // console.log(jsonData);
      //console.log(jsonUrl);
      //console.log(userId);
      //const userId = this.$store.state.storePrePanier.StoreApi
      //var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso ;
      if(this.$store.state.storeUser.lang == 'fr'){
          window.open(this.$store.state.storeGlobal.StoreApi + '/zip-pdf?i=' + encodeURIComponent(userId) + '&u=' + jsonUrlEncrypt + '&lang=fr'   , '_blank');
        }else{
          window.open(this.$store.state.storeGlobal.StoreApi + '/zip-pdf?i=' + encodeURIComponent(userId) + '&u=' + jsonUrlEncrypt + '&lang=en' , '_blank');
        }

    }, 
   /**
     * Ajout au panier Rexel
     */
     addCart(){
     
this.prePanier = this.$store.state.storePrePanier.StoreShowPrePanierListe;


/********************** Ref non gerrée ***********************/
/*
var jsontest = {
"id": "Configurateur fibre optique",
"quantity": 1,
"products": [
{
"quantity": "1",
"reference": "PRET0476",
"productId":"PRET0476",
"edi": "CONFIGURATIONID==ggm-lfwd19o9uqy1m91#REAL_REF==PRK 8TBM3LCLC700#PALLIER_REF==GGMPRET0476"
}
],
}*/
this.jsonData = {
/*  "totalProductCount": this.prePanier.length,*/
"ConfiguratorName":"Fibre préconnectorisée",

"products" : [{
id: "Configurateur fibre optique",
title: "Configurateur fibre optique",
product: []
}]
};


//var count = 0;
var datasPrk = {};

for (let i of this.prePanier) {


/**
* Ajout au panier refrence prk
*/
if( i.etat == true && i.refGerree == false ){

  if( this.$store.state.storeGlobal.StoreEnvWeb == 'Webshop' && this.$store.state.storeGlobal.StorePays == 'NL' ){
    this.jsonData = {
/*  "totalProductCount": this.prePanier.length,*/
"ConfiguratorName":"Gigamedia Glasvezelconfigurator",

"products" : [{
id: "Gigamedia Glasvezelconfigurator",
title: "Gigamedia Glasvezelconfigurator",
product: []
}]
};
   
    datasPrk =  {
  productCode : (this.$CryptoJS.AES.decrypt(i.pa_custom_ref_nl, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).replace(/ /g,''),
  quantity : 1,
  codeRexel: (this.$CryptoJS.AES.decrypt(i.pa_custom_ref_nl, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).replace(/ /g,''),
  manufactureId : 'GGM ' + (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).substring(4),
  brandId : "br382",
  customId : 'C==' + this.storeSessionId + 
  '#R==' + 
  this.$CryptoJS.AES.decrypt(i.pa_prk, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8).replace(/ /g,'') 
  }
}
else{
  datasPrk =  {
  productCode : (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).replace(/ /g,'').substring(3),
  quantity : 1,
  codeRexel: (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).replace(/ /g,''),
  manufactureId : (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).substring(4),
  brandId : "GGM",
  customId : 'C==' + this.storeSessionId + 
  '#R==' + 
  this.$CryptoJS.AES.decrypt(i.pa_prk, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8).replace(/ /g,'') 
  }
}


   this.jsonData.products[0].product.push(datasPrk) ;
// "products" : []

}
if( i.etat == true && i.refGerree == true ){

/*
const datasGgm = {
// ean: this.$CryptoJS.AES.decrypt(i.ean, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8),
productCode: i.ref_prk.replace(/ /g,'').substring(3) ,
manufactureId : i.ref_prk.replace(/ /g,'').substring(3),
brandId : "GGM",
codeRexel: i.ref_prk.replace(/ /g,''),
quantity: 1,
};
*/

const datasGgm = {
  productCode : i.ref_prk.replace(/ /g,'').substring(3),
  quantity : 1,
  codeRexel: i.ref_prk.replace(/ /g,''),
  manufactureId : i.ref_prk.replace(/ /g,'').substring(3),
  brandId : "GGM",
  customId : 'C==' + this.storeSessionId + 
  '#R==' + 
  i.ref_prk.replace(/ /g,'')

};

this.jsonData.products[0].product.push(datasGgm) ;

} 
/*
const datas = {
   quantity : "1",
  productCode : (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).replace(/ /g,''),
  manufactureId : (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).substring(4),
  brandId : "GGM"
  };
*/
//this.jsonData.products[0].product[count] = datas;
//this.jsonData.products.push(datasInit) ;
//count++;

this.globalFunction.updateLogConfiguration(this, i.pk, {"ajout_panier_webshop": true}); 

}



//Qte de produit dan sle prepanier à l'état TRUE
this.jsonData['totalProductCount'] =  this.jsonData.products.length;

this.msg = JSON.stringify(this.jsonData);


/********************** Ref gerrée ***********************/


this.jsonData2 = {
/*  "totalProductCount": this.prePanier.length,*/
"ConfiguratorName":"Fibre préconnectorisée",

"products" : []
};



//var count2 = 0;
//console.log(count2);
for (let i of this.prePanier) {

/**
* Ajoute au panier reference gerree
*/
if( i.etat == true && i.refGerree == true ){

const datasInit2 = {
id: "Configurateur fibre optique",
title: "Configurateur fibre optique",
product: [{
  ean: this.$CryptoJS.AES.decrypt(i.ean, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8),
  productCode: i.ref_prk.replace(/ /g,'') ,
  quantity: 1,
}],
};

this.jsonData2.products.push(datasInit2);

//count2++;

//console.log(i.ref_prk); // affiche 3, 5, 7 dans la console
//console.log(this.prePanier)
this.globalFunction.updateLogConfiguration(this, i.pk, {"ajout_panier_webshop": true}); 

}

}

//Qte de produit dan sle prepanier à l'état TRUE
this.jsonData2['totalProductCount'] =  this.jsonData2.products.length;


this.msg = JSON.stringify(this.jsonData);

//console.log(JSON.stringify(jsontest));
//parent.postMessage(JSON.stringify(jsontest),"*");

parent.postMessage(this.msg,"*");

this.showRecap = false

/*
if(count > 0){
console.log(this.msg);
//console.log(JSON.stringify(jsontest));
//parent.postMessage(JSON.stringify(jsontest),"*");
parent.postMessage(this.msg,"*");
}
if(count2 > 0){
console.log(this.msg2);
parent.postMessage(this.msg2,"*");
}
*/

}
}

}

</script>

<style>

</style>

